import React from 'react';
import { useTranslation } from 'react-i18next';

// Horizontal "Coming soon" watermark band for surfaces that are still in
// development but already visible to real customers/admins (3D Preview,
// per product request 2026-08-14). `pointerEvents: 'none'` on both this
// wrapper and the band itself so the model underneath stays fully orbitable/
// zoomable — this is a visual flag, not a feature gate.
export function ComingSoonOverlay() {
  const { t } = useTranslation();
  return (
    <div
      aria-hidden
      style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 10 }}
    >
      <div
        style={{
          position: 'absolute', top: '38%', left: 0, width: '100%',
          textAlign: 'center',
          background: 'rgba(15, 23, 42, 0.22)', color: '#fff',
          padding: '8px 0', fontSize: 15, fontWeight: 700, letterSpacing: 1.5,
          textTransform: 'uppercase',
        }}
      >
        {t('designer.preview3d.comingSoon')}
      </div>
    </div>
  );
}
